import {Component, Input, OnInit} from '@angular/core';
import {
  Aangifte,
  AangifteBerekening, BokkzAlgDataService,
  Box1Berekening,
  Box2Berekening, Box3Berekening, HeffingskortingenBerekening, IncomeTaxEntity,
  OpbouwBox1, OpbouwBox2, OpbouwBox3, OpbouwHeffingskortingen, OpbouwPGA
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject} from "rxjs";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SpecBelastingBox1Component } from './spec-belasting-box1/spec-belasting-box1.component';
import { SpecBelastingBox2Component } from './spec-belasting-box2/spec-belasting-box2.component';
import { SpecBelastingBox3Component } from './spec-belasting-box3/spec-belasting-box3.component';
import {
  SpecPremieVolksverzekeringenComponent
} from '../premie-volksverzekeringen/spec-premie-volksverzekeringen/spec-premie-volksverzekeringen.component';
import { HeffingskortingenBerekeningenComponent } from '../heffingskortingen/heffingskortingen.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-inkomstenbelasting',
  templateUrl: './inkomstenbelasting.component.html',
  styleUrls: ['./inkomstenbelasting.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SpecBelastingBox1Component,
    SpecBelastingBox2Component,
    SpecBelastingBox3Component,
    SpecPremieVolksverzekeringenComponent,
    HeffingskortingenBerekeningenComponent,
    CommonModule
  ]
})
export class InkomstenbelastingComponent implements OnInit {
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;
    private partnerAangifte = {} as Aangifte;

    berekeningFormGroup = this.fb.group<AangifteBerekening>({});
    berekening = {} as AangifteBerekening;

    public revisierenteAangever?: number;
    public revisierentePartner?: number;

    public wetgevingFg = {} as FormGroup;

    public revisierenteForm = this.fb.group({
        revisierenteAangever: null as unknown as number,
        revisierentePartner: null as unknown as number,
    });

    public dialogUitlegVisible = false;

    public dialogSpecInkomstenbelastingVisible = false;

    get inkomenLabel(): string {
        return this.berekeningFormGroup.get('box1.persoonsgebondenAftrek')?.value > 0 ? 'Inkomen' : '';
    }

    showDialogSpecInkomstenbelasting() {
        this.dialogSpecInkomstenbelastingVisible = true;
    }

    public dialogSpecPVVVisible = false;

    showDialogSpecPVV() {
        this.dialogSpecPVVVisible = true;
    }

    public dialogSpecHeffingskortingenVisible = false;

    showDialogSpecHeffingskortingen() {
        this.dialogSpecHeffingskortingenVisible = true;
    }

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.berekeningFormGroup = this.fb.group<AangifteBerekening>(({
            box1: this.fb.group<Box1Berekening>(({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                inkomstenbelasting: null as unknown as number,
                conserverendeAanslag: null as unknown as number,
                opbouwInkomen: this.fb.group<OpbouwBox1>(({
                    winstUitOnderneming: null as unknown as number,
                    belastbaarloon: null as unknown as number,
                    resultaatUitOverigeWerkzaamheden: null as unknown as number,
                    periodiekeUitkeringen: null as unknown as number,
                    inkomstenUitEigenWoning: null as unknown as number,
                    saldoEigenWoning: null as unknown as number,
                    negatieveUitgavenVoorInkomensvoorzieningen: null as unknown as number,
                    negatievePersoonsgebondenAftrek: null as unknown as number,
                    overigeInkomsten: null as unknown as number,
                    aftrekWegensGeenOfGeringeEigenWoningSchuld: null as unknown as number,
                    uitgavenVoorInkomensvoorzieningen: null as unknown as number,
                    verrekendVerlies: null as unknown as number,
                } as OpbouwBox1)),
            } as Box1Berekening)),
            box2: this.fb.group<Box2Berekening>(({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                inkomstenbelasting: null as unknown as number,
                conserverendeAanslag: null as unknown as number,
                opbouwInkomen: this.fb.group<OpbouwBox2>(({
                    inkomenUitAanmerkelijkBelang: null as unknown as number,
                    verrekendVerlies: null as unknown as number,
                    saldoAanmerkelijkBelang: null as unknown as number,
                } as OpbouwBox2)),
            } as Box2Berekening)),
            box3: this.fb.group<Box3Berekening>(({
                inkomen: null as unknown as number,
                persoonsgebondenAftrek: null as unknown as number,
                belastbaarInkomen: null as unknown as number,
                inkomstenbelasting: null as unknown as number,
                opbouwInkomen: this.fb.group<OpbouwBox3>(({
                    voordeelUitSparenEnBeleggen: null as unknown as number,
                    grondslagNaVerdeling: null as unknown as number,
                    grondslagSparenEnBeleggen: null as unknown as number,
                    waardeBezittingenBinnenlandsePeriode: null as unknown as number,
                    waardeSchuldenBinnenlandsePeriode: null as unknown as number,
                    waardeBezittingenBuitenlandsePeriode: null as unknown as number,
                    waardeSchuldenBuitenlandsePeriode: null as unknown as number,
                    rendementsGrondslagBinnenlandsePeriode: null as unknown as number,
                    rendementsGrondslagBuitenlandsePeriode: null as unknown as number,
                    drempelSchuldenBinnenlandsePeriode: null as unknown as number,
                    drempelSchuldenBuitenlandsePeriode: null as unknown as number,
                    grondslagBinnenlandsePeriode: null as unknown as number,
                    grondslagBuitenlandsePeriode: null as unknown as number,
                    aandeelGrondslagBinnenlandsePeriode: null as unknown as number,
                    aandeelGrondslagBuitenlandsePeriode: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVerminderingBinnenlandsePeriode: null as unknown as number,
                    voordeelSparenEnBeleggenVoorVerminderingBuitenlandsePeriode: null as unknown as number,
                    eldersBelasteRechtenOnroerendeZakenBuitenland: null as unknown as number,
                    verminderingVanwegeEldersBelasteRechtenBuitenland: null as unknown as number,
                    bezittingenDieMeetellenVoorTijdsevenredigeHerleidingBinnenlandsePeriode: null as unknown as number,
                    verminderingVoordeelTijdevenredigeHerleiding: null as unknown as number,
                    voordeelUitSparenEnBelegenBinnenlandsePeriode: null as unknown as number,
                    voordeelUitSparenEnBelegenBuitenlandsePeriode: null as unknown as number,
                } as OpbouwBox3)),
            } as Box3Berekening)),
            opbouwPGA: this.fb.group<OpbouwPGA>(({
                restantPgaVoorgaandeJaren: null as unknown as number,
                onderhoudsverplichtingen: null as unknown as number,
                specifiekeZorgkosten: null as unknown as number,
                weekenduitgaven: null as unknown as number,
                scholingsuitgaven: null as unknown as number,
                monumentenpanden: null as unknown as number,
                aftrekbareGiften: null as unknown as number,
                kwijtscheldingDurfkapitaal: null as unknown as number,
                aandeelPartnerPga: null as unknown as number,
            } as OpbouwPGA)),
            heffingskortingen: this.fb.group<HeffingskortingenBerekening>(({
                totaal: null as unknown as number,
                opbouw: this.fb.group<OpbouwHeffingskortingen>(({
                    algemeneHeffingskorting: null as unknown as number,
                    arbeidskorting: null as unknown as number,
                    inkomensafhankelijkeCombinatieKorting: null as unknown as number,
                    ouderenkorting: null as unknown as number,
                    alleenstaandeOuderenkorting: null as unknown as number,
                    wajong: null as unknown as number,
                    grondslagGroeneBeleggingen: null as unknown as number,
                    groeneBeleggingen: null as unknown as number,
                    levensloopverlof: null as unknown as number,
                    werkbonus: null as unknown as number,
                    vutkorting: null as unknown as number,
                    maximering: null as unknown as number,
                    verhogingPartner: null as unknown as number,
                } as OpbouwHeffingskortingen))
            } as HeffingskortingenBerekening)),
            premieVolksverzekeringen: null as unknown as number,
            gecombineerdeInkomensheffing: null as unknown as number,
            verrekendeBelastingKortingBox2: null as unknown as number,
            alBetaaldeLoonbelasting: null as unknown as number,
            alBetaaldeDividendbelasting: null as unknown as number,
            voorlopigeAanslag: null as unknown as number,
            voorlopigeTeruggaaf: null as unknown as number,
            aanslaggrens: null as unknown as number,
            verschuldigdeInkomstenbelasting: null as unknown as number,
            verschuldigdeZVW: null as unknown as number,
            nietToegerekendePga: null as unknown as number,
            verzamelinkomen: null as unknown as number,
            tussentellingVerzamelinkomenBijNihilInkomens: null as unknown as number,
            totaalInkomstenbelasting: null as unknown as number,
            tussentellingGecombIHEnVA: null as unknown as number,
            tussentellingTeVerrekenen: null as unknown as number,
            tussentellingNaTeVerrekenenBedragen: null as unknown as number,
            multipliedValue: null as unknown as number,
        } as AangifteBerekening));
        this.wetgevingFg = this.fb.group({
            box1PercentageSchijf1: null as unknown as number | undefined,
            box1PercentageSchijf2: null as unknown as number | undefined,
            box1PercentageSchijf3: null as unknown as number,
            box2PercentageSchijf1: null as unknown as number,
            box2PercentageSchijf2: null as unknown as number,
            box3Percentage: null as unknown as number
        });
    }

    calculateTotaalInkomstenbelasting(): void {
        const box1Inkomstenbelasting = this.berekening?.box1?.inkomstenbelasting || 0;
        const box2Inkomstenbelasting = this.berekening?.box2?.inkomstenbelasting|| 0;
        const box3Inkomstenbelasting = this.berekening?.box3?.inkomstenbelasting|| 0;
        const totaalInkomstenbelasting = box1Inkomstenbelasting + box2Inkomstenbelasting + box3Inkomstenbelasting;
        this.berekeningFormGroup.get('totaalInkomstenbelasting')?.patchValue(totaalInkomstenbelasting);

        const voorlAanslag = this.berekening?.voorlopigeAanslag|| 0;
        let voorlTeruggaaf = 0
        if (voorlAanslag < 0) {
            voorlTeruggaaf = voorlAanslag * -1
        }
        this.berekeningFormGroup.get('voorlopigeTeruggaaf')?.patchValue(voorlTeruggaaf);

    }

    calculateTussenTellinGVerzamelinkomenBijNihilInkomens(): void {
        const belastbaarInkomenBox1 = this.berekening?.box1?.belastbaarInkomen || 0;
        const belastbaarInkomenBox2 = this.berekening?.box2?.belastbaarInkomen || 0;
        const belastbaarInkomenBox3 = this.berekening?.box3?.belastbaarInkomen || 0;
        const nieuwVerzamelinkomen = belastbaarInkomenBox1 + belastbaarInkomenBox2 + belastbaarInkomenBox3;
        this.berekeningFormGroup.get('tussentellingVerzamelinkomenBijNihilInkomens')?.patchValue(nieuwVerzamelinkomen);
    }

    calculateTussentellingen(): void {
        const gecombineerdeIKH = this.berekening?.gecombineerdeInkomensheffing|| 0;
        const heffingskortingen = this.berekening?.heffingskortingen?.totaal||0;
        const ingehoudenloonheffing = this.berekening?.alBetaaldeLoonbelasting|| 0;
        const teVerrekenenDividendbelasting = this.berekening?.alBetaaldeDividendbelasting|| 0;
        const teVerrekenenBelastingkortingBox2 = this.berekening?.verrekendeBelastingKortingBox2|| 0;
        const voorlopigeAanslag = this.berekening?.voorlopigeAanslag|| 0;

        let tussentellingGecombIHEnVA = 0;
        if (voorlopigeAanslag < 0) {
            tussentellingGecombIHEnVA = gecombineerdeIKH + voorlopigeAanslag;
        } else {
            tussentellingGecombIHEnVA = gecombineerdeIKH;
        }
        this.berekeningFormGroup.get('tussentellingGecombIHEnVA')?.patchValue(tussentellingGecombIHEnVA);

        let tussentellingTeVerrekenen: number;
        if (voorlopigeAanslag >= 0) {
            tussentellingTeVerrekenen = heffingskortingen + ingehoudenloonheffing + teVerrekenenDividendbelasting + teVerrekenenBelastingkortingBox2 + voorlopigeAanslag;
        } else {
            tussentellingTeVerrekenen = heffingskortingen + ingehoudenloonheffing + teVerrekenenDividendbelasting + teVerrekenenBelastingkortingBox2;
        }
        this.berekeningFormGroup.get('tussentellingTeVerrekenen')?.patchValue(tussentellingTeVerrekenen);

        let tussentellingNaTeVerrekenenBedragen = 0;
        tussentellingNaTeVerrekenenBedragen = gecombineerdeIKH - tussentellingTeVerrekenen;
        this.berekeningFormGroup.get('tussentellingNaTeVerrekenenBedragen')?.patchValue(tussentellingNaTeVerrekenenBedragen);
    }

    public ngOnInit(): void {
        this.partner.subscribe((partner) => {
            this.berekeningFormGroup.reset();
            if (partner) {
                this.dataService.aangifteBerekening.subscribe((berekening) => {
                    if(berekening.partnerBerekening) {
                        this.berekening = berekening.partnerBerekening;
                        this.berekeningFormGroup.patchValue(this.berekening)
                        this.doBerekeningen()
                    }
                });
            } else {
                this.dataService.aangifteBerekening.subscribe((berekening) => {
                    this.berekening = berekening;
                    this.berekeningFormGroup.patchValue(this.berekening)
                    this.doBerekeningen()
                });
            }
            this.disableFormGroup(this.berekeningFormGroup);
        });
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                })
                this.revisierenteForm.patchValue({
                    revisierenteAangever: incomeTaxEntity.aangifte?.box1
                        ?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.revisierente ?? null,
                    revisierentePartner: incomeTaxEntity.aangifte?.partnerAangifte?.box1
                        ?.belastbarePeriodiekeUitkeringenEnVerstrekkingen?.revisierente ?? null,
                });
            }
        });

    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    private doBerekeningen() {
        if (this.berekening.box1?.inkomstenbelasting || this.berekening.box2?.inkomstenbelasting || this.berekening.box3?.inkomstenbelasting) {
                this.calculateTotaalInkomstenbelasting();
                this.calculateTussentellingen()
                this.calculateTussenTellinGVerzamelinkomenBijNihilInkomens();
        }
        if (this.berekening.heffingskortingen?.totaal) {
                this.calculateTussentellingen()
        }
    }
}



